var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.75,
    width: 17.5,
    height: 17.5,
    rx: 8.75,
    fill: "#1275B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8866 6.55759C7.8866 7.14169 7.38032 7.61519 6.7558 7.61519C6.13128 7.61519 5.625 7.14169 5.625 6.55759C5.625 5.9735 6.13128 5.5 6.7558 5.5C7.38032 5.5 7.8866 5.9735 7.8866 6.55759Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77964 8.39256H7.71263V14.25H5.77964V8.39256Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8247 8.39256H8.89175V14.25H10.8247C10.8247 14.25 10.8247 12.406 10.8247 11.253C10.8247 10.561 11.061 9.86596 12.0039 9.86596C13.0694 9.86596 13.063 10.7716 13.058 11.4732C13.0515 12.3903 13.067 13.3262 13.067 14.25H15V11.1586C14.9836 9.18461 14.4693 8.27505 12.7771 8.27505C11.7721 8.27505 11.1492 8.73129 10.8247 9.14406V8.39256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6ff67e1891c74ce618e3fa7b65313c96.svg";
export { ForwardRef as ReactComponent };